import {
  ScopeOfPracticeEnum,
  ShiftTypeEnum,
  ShiftStatusEnum,
  TimeString
} from '@umss/shared/utils';

// Base entity with common fields
interface BaseEntityDto {
  id: string; // Guid
  createdAt: string; // DateTime as ISO string
  updatedAt?: string | null; // DateTime as ISO string
}

// Type of unified shift item
export enum UnifiedShiftItemTypeEnum {
  Shift = 'shift',
  ShiftNeed = 'shiftNeed'
}

// Unified DTO that represents both Shifts and ShiftNeeds
// This allows the UI to handle both types of entities in a unified way
export interface UnifiedShiftDto extends BaseEntityDto {
  itemType: UnifiedShiftItemTypeEnum;

  shiftNeedId: string | null;

  facilityId: string;
  facilityName: string;

  // Only populated for assigned shifts
  contractorId: string | null;
  contractorFirstName: string | null;
  contractorLastName: string | null;
  contractorFullName: string | null;

  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay: string;
  shiftType: ShiftTypeEnum;
  shiftTypeDisplay: string;

  facilitySubtypeId: number | null;
  facilitySubtypeName: string | null;

  shiftDate: string; // DateOnly as ISO string (YYYY-MM-DD)
  startTime: TimeString; // TimeOnly as string (HH:mm:ss)
  endTime: TimeString; // TimeOnly as string (HH:mm:ss)

  status: ShiftStatusEnum;
  statusDisplay: string;
  hourlyRate: number | null;
  specialInstructions: string | null;

  // Only for ShiftNeeds - total positions requested
  numberOfPositions: number | null;

  // Only for ShiftNeeds - positions already filled
  filledPositions: number | null;

  // Facility invited a contractor; contractor hasn't responded yet.
  pendingInviteCount: number | null;
  // Contractor applied; facility hasn't responded yet.
  pendingApplicationCount: number | null;
  // Facility's turn to act: negotiating (contractor last counter-offered) or contractor_accepted awaiting confirm.
  awaitingFacilityActionCount: number | null;
}
